import { defineStore } from 'pinia';
import type { IKeyArrayString, IKeyString, IMenu, IMenus } from '@coreInterfaces/interface';

export const useMenuStore = defineStore('menu-store', {
    state: () => {
        return {
            allMenus: {} as IMenus,
            currentMenus: {} as IMenus,
            menus: {} as IMenus,
            parentMenus: {} as IKeyArrayString,
            pathKey: {} as IKeyString
        };
    },

    getters: {
        getAllMenus: (state) => (): IMenus => {
            return state.allMenus;
        },

        getCurrentMenus: (state) => (): Object => {
            return state.currentMenus;
        },

        getMenus: (state) => (): IMenus => {
            return state.menus;
        },

        getMenuByKey:
            (state) =>
            (key: string): any => {
                if (key in state.menus) {
                    return state.menus[key];
                }

                return null;
            },

        getParentMenus: (state) => (): IKeyArrayString => {
            return state.parentMenus;
        },

        getPermitMenu: (state) => (): IKeyString => {
            return state.pathKey;
        },

        getPermitMenuKey:
            (state) =>
            (path: string): string | null => {
                if (path in state.pathKey) {
                    return state.pathKey[path];
                }

                for (let pkey in state.pathKey) {
                    if (path.includes(pkey)) {
                        return state.pathKey[pkey];
                    }
                }

                return null;
            }
    },

    actions: {
        clearMenuStore(): void {
            this.setCurrentMenus({});
            this.setMenus({});
        },

        setAllMenu(menus: IMenus): void {
            this.allMenus = menus;
            this.setMenuPathKey(this.allMenus);
        },

        setCurrentMenus(menus: IMenus): void {
            this.currentMenus = menus;
        },

        setMenus(menus: IMenus): void {
            this.menus = menus;
        },

        setMenuPathKey(menus: IMenus): void {
            const assignPathKeys = (menu: IMenu): void => {
                this.pathKey[menu.path.path] = menu.key as string;

                if (menu.path.childs) {
                    for (const childPath of menu.path.childs) {
                        this.pathKey[childPath] = menu.key as string;
                    }
                }
            };

            for (const group of Object.values(menus)) {
                for (const item of group) {
                    if ('isParent' in item && item.isParent && item.child) {
                        this.pathKey[item.path.path] = `${item.key}` as string;

                        for (const child of item.child) {
                            assignPathKeys(child);
                        }
                    } else {
                        assignPathKeys(item);
                    }
                }
            }
        },

        setParentMenus(parentKey: string, childs: string[]): void {
            this.parentMenus[parentKey] = childs;
        }
    }
});
